import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useCart } from '../contexts/CartContext'
import './AddToCartNotification.css'

const AddToCartNotification = ({ product, quantity, onClose }) => {
  const navigate = useNavigate()
  const { getTotalItems } = useCart()

  const handleViewCart = () => {
    navigate('/cart')
    onClose()
  }

  const productImage = product.images && product.images.length > 0 
    ? product.images[0] 
    : product.image || ''

  const productName = product.name?.en || product.name || 'Product'
  const productPrice = product.price || product.selectedPrice || 0
  const sizeText = product.selectedSize ? `Size: ${product.selectedSize}` : ''
  const styleText = product.selectedSku ? `Style: ${product.selectedSku}` : ''

  return (
    <div className="add-to-cart-notification-overlay" onClick={onClose}>
      <div className="add-to-cart-notification" onClick={(e) => e.stopPropagation()}>
        <button className="notification-close" onClick={onClose}>×</button>
        
        <div className="notification-header">
          <div className="notification-checkmark">✓</div>
          <h3>Added to Bag</h3>
        </div>

        <div className="notification-product">
          <img 
            src={productImage} 
            alt={productName}
            className="notification-product-image"
          />
          <div className="notification-product-info">
            <h4>{productName}</h4>
            <p className="notification-category">{product.category || ''}</p>
            {sizeText && <p className="notification-detail">{sizeText}</p>}
            {styleText && <p className="notification-detail">{styleText}</p>}
            <p className="notification-price">${productPrice.toFixed(2)}</p>
          </div>
        </div>

        <div className="notification-actions">
          <button 
            className="notification-view-cart-btn"
            onClick={handleViewCart}
          >
            View Cart ({getTotalItems()})
          </button>
        </div>
      </div>
    </div>
  )
}

export default AddToCartNotification

